import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';

function Login({ onLoginSuccess, onCancel }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        username,
        password
      });

      if (response.data.success) {
        localStorage.setItem('adminToken', response.data.token);
        onLoginSuccess({
          token: response.data.token,
          username: response.data.username,
          role: response.data.role,
          department_id: response.data.department_id
        });
      } else {
        setError(response.data.error || 'Invalid credentials');
      }
    } catch (error) {
      setError(
        error.response?.data?.error || 'Server error. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">

      <div className="login-branding">
        <div className="login-lcars-bar" />
        <div className="login-title-block">
          <span className="login-title-main">SHORE LEAVE</span>
          <span className="login-title-sub">VOLUNTEER OPERATIONS</span>
        </div>
      </div>

      <div className="login-card">
        {onCancel && (
          <button
            type="button"
            className="login-back-btn"
            onClick={onCancel}
            disabled={loading}
            aria-label="Back to volunteer sign up"
          >
            ← Back
          </button>
        )}
        <h2 className="login-heading">Admin Access</h2>

        {error && (
          <div className="login-error">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="username"
              disabled={loading}
              autoCapitalize="none"
              autoCorrect="off"
              required
            />
          </div>

          <div className="login-field">
            <label htmlFor="password">Password</label>
            <div className="login-password-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="password"
                disabled={loading}
                required
              />
              <button
                type="button"
                className="login-show-btn"
                onClick={() => setShowPassword(p => !p)}
                tabIndex={-1}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'HIDE' : 'SHOW'}
              </button>
            </div>
          </div>

          <button type="submit" className="login-submit-btn" disabled={loading}>
            {loading ? 'AUTHENTICATING…' : 'LOGIN'}
          </button>
        </form>
      </div>

    </div>
  );
}

export default Login;
